import { AccountCategory, AccountType, CategoryType, HiringSite } from 'eve-account-client';
import { AccessMethodFormData } from '../../components/Enrollment/AccessMethod/AccessMethodFormData';
import { CompanyAddressesFormData } from '../../components/Enrollment/CompanyAddresses/CompanyAddressesFormData';
import CompanyInformationFormData from '../../components/Enrollment/CompanyInformation/CompanyInformationFormData';
import { MarketingChannel } from '../../components/Enrollment/CompanyInformation/MarketingChannel';
import EVerifyUser from '../../components/Enrollment/EVerifyUsers/data/EVerifyUser';

export enum EnrollmentType {
  INITIAL,
  CHILD,
  CLIENT,
}

export interface EnrollmentData {
  enrollmentType: EnrollmentType;
  accessMethodFormData?: AccessMethodFormData;
  employerCategoryFormData?: AccountCategory;
  companyInformationFormData?: CompanyInformationFormData;
  companyAddressesFormData?: CompanyAddressesFormData;
  hiringSitesFormData?: HiringSite[];
  bulkUploadErrors?: HiringSite[];
  defaultHiringSiteCreated: boolean;
  mouSignatoryIsSame?: boolean;
  everifyUserFormData?: EVerifyUser[];
  marketingChannel?: MarketingChannel;
}

export const shouldEvePlusToSBeHidden = (
  webServiceAccess: boolean | undefined,
  accessMethod: AccountType | undefined,
  employerCategory: string | undefined,
): boolean => {
  return (
    webServiceAccess === true ||
    accessMethod === AccountType.CORPORATE ||
    accessMethod === AccountType.AGENCY ||
    accessMethod === AccountType.CLIENT ||
    employerCategory === CategoryType.AIRPORTOPERATORS
  );
};
